import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=45d27f2e&"
import script from "./Download.vue?vue&type=script&setup=true&lang=js&"
export * from "./Download.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports